import { mavonEditor } from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
export default {
  components: {
    mavonEditor
  },
  data() {
    return {
      content: '',
      html: ''
    };
  },
  methods: {
    // 所有操作都会被解析重新渲染
    change(value, render) {
      console.log(value);
      // render 为 markdown 解析后的结果[html]
      this.html = render;
    },
    // 提交
    submit() {
      console.log(this.content);
      console.log(this.html);
    }
  }
};